import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AdminInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      const res = await axios.get('/api/admin/invoices');
      setInvoices(res.data);
    } catch (error) {
      console.error('Error fetching invoices:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await axios.put(`/api/admin/invoices/${id}/approve`);
      fetchInvoices();
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to approve invoice');
    }
  };

  const getStatusBadge = (status) => {
    const statusClass = `badge badge-${status.toLowerCase().replace(' ', '-')}`;
    return <span className={statusClass}>{status}</span>;
  };

  if (loading) {
    return <div className="loading">Loading invoices...</div>;
  }

  return (
    <div>
      <h2>Invoices</h2>
      {invoices.length === 0 ? (
        <div className="card">
          <p>No invoices found.</p>
        </div>
      ) : (
        <div>
          {invoices.map(invoice => (
            <div key={invoice._id} className="card">
              <h3>Invoice Number: {invoice.invoiceNumber}</h3>
              <p><strong>Status:</strong> {getStatusBadge(invoice.status)}</p>
              <p><strong>Total Amount:</strong> ${invoice.totalAmount}</p>
              <p><strong>PO Number:</strong> {invoice.purchaseOrderId?.poNumber}</p>
              <p><strong>Transportation Company:</strong> {invoice.transportationCompany?.name || 'N/A'}</p>
              {invoice.dueDate && <p><strong>Due Date:</strong> {new Date(invoice.dueDate).toLocaleDateString()}</p>}
              <p><strong>Issued At:</strong> {new Date(invoice.issuedAt).toLocaleString()}</p>
              {invoice.notes && <p><strong>Notes:</strong> {invoice.notes}</p>}
              <div style={{ marginTop: '15px' }}>
                <h4>Associated Routes:</h4>
                <ul>
                  {invoice.routes.map(route => (
                    <li key={route._id}>
                      {route.routeNumber} - {route.startPoint} to {route.endPoint} (${route.price})
                    </li>
                  ))}
                </ul>
              </div>
              {invoice.status === 'submitted' && (
                <button className="btn btn-success" onClick={() => handleApprove(invoice._id)} style={{ marginTop: '15px' }}>
                  Approve Invoice
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminInvoices;
